export enum FtpType {
  FTP = 'FTP',
  SFTP = 'SFTP',
  FTPS = 'FTPS'
}
